import { view } from '@yola/ws-sdk';
import { VIEW_WIDTH_CSS_VAR } from '../constants/common';

const getViewLeftOffset = () => {
  const value = document.body.style.getPropertyValue(VIEW_WIDTH_CSS_VAR);

  if (!value || value === '100%') return 0;

  const viewWidth = parseInt(value, 10);
  // The view is centred in what's left of the window once the docked panel has
  // taken its share, not in the window itself.
  const availableWidth = view.accessors.getAvailableViewportWidth();

  return Math.max(0, (availableWidth - viewWidth) / 2);
};

export default getViewLeftOffset;
